import React from 'react'
import styled from '@emotion/styled'
import TimeAgo from '../TimeAgo'
import {
  Avatar,
  H4,
  color,
  shadow,
  space,
  fontSize,
  radius,
} from '@ticketswap/solar'

const Container = styled.div`
  width: 100%;
  box-shadow: ${shadow.strong};
  padding: ${space[24]};
  border-radius: ${radius.lg};
  background-color: white;
`

const Time = styled.time`
  font-size: ${fontSize[14]};
  display: block;
  color: ${color.spaceLight};
`

const Message = styled.p`
  margin: 0;
  white-space: normal;
`

const ItemHeader = styled.header`
  display: inline-flex;
  align-items: center;
  margin-bottom: ${space[16]};
`

const AvatarContainer = styled.div`
  margin-right: ${space[16]};
`

function TestimonialCard({ ...props }) {
  return (
    <Container {...props}>
      <ItemHeader>
        <AvatarContainer>
          <Avatar size={48} src={props.user.avatar} />
        </AvatarContainer>
        <div>
          <H4>{props.user.firstname}</H4>
          <Time>
            <TimeAgo date={props.createdAt} />
          </Time>
        </div>
      </ItemHeader>
      <Message>{props.description}</Message>
    </Container>
  )
}

export default TestimonialCard
